import { grey } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

//TODO: THEME NEEDS SOME REWRITE

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    legacy: true;
  }
}

const themeColors = {
  black: '#000',
  white: '#fff',
  white1: '#f6f6f6',

  blue: '#05A4D8',
  blue2: '#025874',
  blue3: '#0491bf',

  green: '#1fa67a',
  green2: '#59CAC3',
  green3: '#3CA789',

  yellow: '#ebc111',
  red: '#f30',

  grey1: '#f2f2f5',
  grey2: '#eaeaea',
  grey3: '#e7e7e7',
  grey4: '#D6D6D6',
  grey5: '#ccc',
  grey6: '#bdbdbd',
  grey7: '#6f6f6f',
};

export const legacyColors = {
  ...themeColors,

  primary: themeColors.blue,
  icon: {
    help: themeColors.green,
  },
  button: {
    text: '#336699',
    textDanger: '#dd5143',
  },
  text: {
    default: '#454545',
    highlight: themeColors.black,
    error: themeColors.red,
    success: '#090',
  },
  modules: {
    people: themeColors.blue,
    rewarding: '#3b873b',
    performance: '#ff6600',
    development: '#A89A07',
    analytics: '#cc3366',
    collaboration: '#046980',
    organization: '#000033',
    recruiting: '#660099',
    planning: '#339999',
  },
};

export const legacyShadows = {
  drop1: `0 6px 12px rgb(0 0 0 / 18%)`,
  inset1: `inset 0 0 5px ${legacyColors.grey4}`,
};

const primaryColor = '#05a4d8';
const secondaryColor = '#ffc000';
const darkSurfaceColor = '#fcfcfc';
const textPrimaryColor = '#587985';
const tableHeadColor = '#aaaaaa';

export const legacyTheme = createTheme({
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          color: textPrimaryColor,
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '@global': {
          '*': {
            scrollbarWidth: 'thin',
            scrollbarColor: '#CDCDCD #F0F0F0',
          },
          '*::-webkit-scrollbar': {
            width: 7.5,
            height: 7.5,
          },
          '*::-webkit-scrollbar-track': {
            backgroundColor: '#F0F0F0',
          },
          '*::-webkit-scrollbar-thumb': {
            backgroundColor: '#CDCDCD',
            borderRight: '1px solid white',
            borderBottom: '1px solid white',
            '&:hover': {
              backgroundColor: '#A6A6A6',
            },
            '&:active': {
              backgroundColor: '#606060',
            },
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        input: {
          '&[placeholder]': {
            textOverflow: 'ellipsis',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: tableHeadColor,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: darkSurfaceColor,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          minWidth: 'inherit',
          textTransform: 'none',
          width: 'inherit',
        },
        textColorInherit: {
          color: textPrimaryColor,
          opacity: 1,
          '&$selected': {
            color: primaryColor,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: primaryColor,
          height: 4,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedSecondary: {
          color: themeColors.white,
          backgroundColor: themeColors.blue,
          '&:hover': {
            color: themeColors.white,
            backgroundColor: themeColors.blue,
          },
        },
        contained: {
          color: themeColors.black,
          backgroundColor: themeColors.grey3,
          '&:hover': {
            color: themeColors.black,
            backgroundColor: themeColors.grey4,
          },
        },
      },
    },
  },
  palette: {
    primary: {
      contrastText: grey[50],
      main: primaryColor,
    },
    secondary: {
      contrastText: grey[50],
      main: secondaryColor,
    },
  },
});
